/*
  This file is intended to hold types and interfaces for structured tables that are defined in the backend
*/

export interface TableValidationErrorText {
  error_uuid: string;
  message: string;
  validation_rule_id: string;
  overridable: boolean;
  bypassed?: boolean;
}
export interface TableValidationCellError {
  columnProvenanceUuid: string;
  rowId: string;
  text: Array<TableValidationErrorText>;
}
export interface TableValidationResponse {
  error: string;
  tableName: string;
  tableErrors: Array<TableValidationCellError>;
  startIndex?: number;
  endIndex?: number;
}
export type OptionalTableValidationResponse = TableValidationResponse | null;

// This must stay in sync with TABLE_VALIDATION_ERROR_MESSAGE in
// evaluate_validation_rules_for_structured_table.py
export const TABLE_VALIDATION_ERROR_MESSAGE = 'Table validation error';

// Must stay in sync with AI_MISMATCH_VALIDATION_RULE_ID in ai_data_entry_verification_errors.py
export const AI_MISMATCH_VALIDATION_RULE_ID = 'ai_data_entry_mismatch';

export class TableValidationError extends Error {
  validationResponse: TableValidationResponse;
  userMessage: string = 'Table failed validation.  See table for errors.';

  constructor(validationResponse: TableValidationResponse) {
    super(validationResponse.error);
    this.validationResponse = validationResponse;
  }
}
